import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";

import RecordsColumnsSearchByFilter from "./recordsColumnsSearchByFilter";
import EntriesPagination from "./entriesPagination";

const CustomDataTableSearchByFilter = props => {
  const ASC = "asc";
  const DESC = "desc";

  const [blockRefresh, setBlockRefresh] = useState(true); //to prevent api calling twice when the page is initially loaded
  const [selectedSortColumn, setSelectedSortColumn] = useState(null);
  const [currFilters, setCurrFilters] = useState(
    props.tabFilters
      ? props.tabFilters
      : {
          skip: 0,
          limit: 10
        }
  );

  useEffect(() => {
    setSelectedSortColumn(null);
  }, [props.tabFilters]);

  // restore the previous page * updated by entries pagination
  // useEffect(() => {
  //   if (props.tabFilters) {
  //     setCurrFilters(props.tabFilters);
  //     paginationUpdated(props.tabFilters.skip);
  //   }
  // }, []);

  const setRecordsFilters = filters => {
    let newFilter = Object.assign({}, currFilters);
    newFilter.limit = filters.limit;
    newFilter.text = filters.text;
    newFilter.filterType = filters.filterType;

    if (
      props.totalRecords === parseInt(filters.limit) ||
      props.totalRecords <= parseInt(filters.limit)
    ) {
      newFilter.skip = 0;
    }

    setCurrFilters(newFilter);
    props.setFilters(newFilter);
  };

  const paginationUpdated = skip => {
    if (blockRefresh) {
      console.log("first time opening")
      setBlockRefresh(false);
      return;
    }

    let newFilter = Object.assign({}, currFilters);
    newFilter.skip = skip;
    setCurrFilters(newFilter);

    props.setFilters(newFilter);
    setBlockRefresh(true);
  };

  const sortTableByColumn = column => {
    let srt = null;

    if (selectedSortColumn === null || column !== selectedSortColumn.column) {
      srt = {
        order: ASC,
        column: column
      };
    } else if (
      selectedSortColumn !== null &&
      column === selectedSortColumn.column
    ) {
      if (selectedSortColumn.order === ASC) {
        srt = {
          order: DESC,
          column: column
        };
      } else {
        srt = {
          order: ASC,
          column: column
        };
      }
    }

    setSelectedSortColumn(srt);
    if (props.sortData) {
      props.sortData(srt);
    }
  };

  const searchFilterList = [];

  return (
    <div className="data-table-container mt-4">
      {!props.disableFilterPagination && !props.disableTopFilters && (
        <RecordsColumnsSearchByFilter
          recordLimit={props.tabFilters ? props.tabFilters.limit : 10}
          totalRecords={props.totalRecords}
          setFilters={setRecordsFilters}
          disbleAll={props.disbleAll}
          disableSearchText={props.disableSearchText}
          searchFilterList={props.searchFilterList || searchFilterList}
        />
      )}
      <div className="table-container mt-4">
        <table className="table table-bordered table-striped">
          <thead>
            <tr>
              {props.headers.map((header, i) => (
                <th
                  onClick={e => {
                    if (props.sortableTable === true) {
                      if (
                        header.sort === undefined ||
                        (header.sort && header.sort !== false)
                      ) {
                        sortTableByColumn(header.key);
                      }
                    }
                  }}
                  style={header.customStyle ? header.customStyle : {}}
                  key={i}
                  className={
                    selectedSortColumn === null ||
                    header.key !== selectedSortColumn.column
                      ? props.sortableTable === true
                        ? "table-sort"
                        : ""
                      : header.key === selectedSortColumn.column &&
                        selectedSortColumn.order === ASC
                      ? "table-sort-asc"
                      : "table-sort-desc"
                  }
                >
                  {header.value}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {props.totalRecords > 0 && props.children}
            {props.totalRecords === 0 && (
              <tr style={{ backgroundColor: "#fff" }}>
                {props.headers.map((h, i) => {
                  if (i === 0) {
                    return (
                      <td style={{ border: "none" }} key={i}>
                        No data is available
                      </td>
                    );
                  } else {
                    return <td style={{ border: "none" }} key={i}></td>;
                  }
                })}
              </tr>
            )}
          </tbody>
        </table>
      </div>
      {!props.disableFilterPagination && (
        <EntriesPagination
          itemsPerPage={currFilters.limit}
          currPage={props.tabFilters.skip}
          totalRecords={props.totalRecords}
          paginationUpdated={paginationUpdated}
        />
      )}
    </div>
  );
};

export default CustomDataTableSearchByFilter;

CustomDataTableSearchByFilter.defaultProps = {
  header: [],
  totalRecords: 0,
  sortableTable: true,
  disbleAll: false,
  disableSearchText: false,
  disableFilterPagination: false,
  disableTopFilters: false
};

CustomDataTableSearchByFilter.prototype = {
  header: PropTypes.array.isRequired, // table header
  totalRecords: PropTypes.number.isRequired, // total entries count
  setFilters: PropTypes.func.isRequired, // functions to pass filters to parent component
  disableFilterPagination: PropTypes.bool, // disable the top filters and paginations
  sortData: PropTypes.func, // sorting data function
  tabFilters: PropTypes.object, // current filters values
  sortableTable: PropTypes.bool, // to make siorting enable or disable for columns
  disbleAll: PropTypes.bool, // to disable all data fetching for table,
  disableSearchText: PropTypes.bool, // disable the search columns text field
  disableTopFilters: PropTypes.bool
};

/* here table header can contains an array of objects of this type

{
  key: string and the key which will be used for sorting,
  value: string value which will be used in showing the header column,
  customStyle: style object for this column,
  sort: boolean to disable sorting for this column. By default it will be enabled
}

*/
